import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ItAssetsConfigurationService } from '@core/services/itAssetsConfiguration.service';
import { ItAssetsConfigurationActions } from './itAssets-configuration.actions';

@Injectable()
export class ItAssetsConfigurationEffects {
  private actions$ = inject(Actions);
  private itAssetsConfigurationService = inject(ItAssetsConfigurationService);
  private translateService = inject(TranslateService);

  getItAssetsList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ItAssetsConfigurationActions.loadItAssetsConfigurationList),
      mergeMap((data) =>
        this.itAssetsConfigurationService.getItAssetsConfigurationMasterList(data.key, data.data).pipe(
          map((response) =>
            response.success
              ? ItAssetsConfigurationActions.loadItAssetsConfigurationListSuccess({ response, key: data.key })
              : ItAssetsConfigurationActions.loadItAssetsConfigurationListFailure({
                  error: response,
                  key: data.key,
                })
          ),
          catchError((error) =>
            of(
              ItAssetsConfigurationActions.loadItAssetsConfigurationListFailure({
                key: data.key,
                error: {
                  error,
                  success: false,
                  message: this.translateService.instant(
                    'Something went wrong'
                  ),
                },
              })
            )
          )
        )
      )
    )
  );

  updateItAssets$ = createEffect(() =>
      this.actions$.pipe(
        ofType(ItAssetsConfigurationActions.addEditItAssetsConfiguration),
        mergeMap((data) =>
          this.itAssetsConfigurationService.editItAssetsConfiguration(data.key, data.data).pipe(
            map((response) => {
              if (response.success) {
                return ItAssetsConfigurationActions.updateItAssetsConfigurationSuccess({
                  response,
                  key: data.key,
                });
              } else
                return ItAssetsConfigurationActions.updateItAssetsConfigurationFailure({
                  error: response,
                  key: data.key,
                });
            }),
            catchError((error) =>
              of(
                ItAssetsConfigurationActions.updateItAssetsConfigurationFailure({
                  error: {
                    error,
                    success: false,
                    message: this.translateService.instant(
                      'Something went wrong'
                    ),
                  },
                  key: data.key,
                })
              )
            )
          )
        )
      )
    );

}